<template>
  <div id="app" :class="{ new1: user == null }">
    <v-app>
      <v-app-bar
        app
        clipped-left
        style="height: auto; border-bottom: #003a60 solid d-xl-none"
        class="flex-grow-0 custom-header-wrap"
      >
        <div class="row pl-8 resMobHeader">
          <div class="col-md pb-0 pt-md-6">
            <div class="row justify-content-between align-self-center menu-bar">
              <div class="top-bar-title text-center">
                Customer Training Portal
              </div>
              <div class="top-Left-wrap">
                <v-app-bar-nav-icon
                  class="d-xl-none"
                  @click.stop="drawer = !drawer"
                ></v-app-bar-nav-icon>
                <v-toolbar-title
                  class="d-xl-none align-self-center mobile-logo-img"
                  ><a href="/"
                    ><img
                      class="resimg"
                      src="../assets/img/kb-logo.svg"
                      width="150px" /></a
                ></v-toolbar-title>
                <a href="/"
                  ><img
                    class="mbres mb-4 kb-header-logo"
                    src="../assets/img/kb-logo.svg"
                    width="200px"
                /></a>
              </div>
              <div
                class="row col-7 pb-0 align-self-center top-right-language-wrapper desk-top-right"
                style="margin-right: 25px"
              >
                <div
                  class="row justify-content-end align-self-center align-self-md-end right-menu-bar"
                >
                  <div
                    class="mr-md-9 align-self-center language-flags-sec"
                    style="width: 54px"
                  >
                    <v-select
                      class="languagepicker languCustWrap"
                      :menu-props="{ minWidth: '180' }"
                      v-model="selectedlanguage"
                      :items="possiblelanguagesComputed"
                      item-text="name"
                      item-value="shortForm"
                      hide-details
                      @input="setLanguage(selectedlanguage)"
                    >
                      <!-- Selected item (shows flag in the select box) -->
                      <template v-slot:selection="{ item }">
                        <img
                          style="
                            width: 30px;
                            height: 20px;
                            vertical-align: unset;
                          "
                          :src="'/files/flags/' + item.flag"
                          alt="Flag"
                        />
                      </template>

                      <!-- Dropdown items -->
                      <template v-slot:item="{ item }">
                        <!-- Tooltip only for Russia -->
                        <v-tooltip
                          v-if="item.shortForm === 'RU'"
                          bottom
                          class="custom_tip"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              v-bind="attrs"
                              v-on="on"
                              style="
                                display: flex;
                                align-items: center;
                                width: 100%;
                              "
                            >
                              <img
                                style="
                                  width: 30px;
                                  height: 20px;
                                  margin-right: 5px;
                                "
                                :src="'/files/flags/' + item.flag"
                                alt="Flag"
                              />
                              {{
                                item.shortForm === "RU"
                                  ? item.name + " *"
                                  : item.name
                              }}
                            </div>
                          </template>
                          <span>{{ $t("menu_tooltip_text") }}</span>
                          <!-- Dynamic Tooltip Text -->
                        </v-tooltip>

                        <!-- Normal display for other countries (No tooltip) -->
                        <div v-else style="display: flex; align-items: center">
                          <img
                            style="width: 30px; height: 20px; margin-right: 5px"
                            :src="'/files/flags/' + item.flag"
                            alt="Flag"
                          />
                          {{
                            item.shortForm === "RU"
                              ? item.name + " *"
                              : item.name
                          }}
                        </div>
                      </template>
                    </v-select>

                    <!-- <v-img @click="nothing()" width="26px" height="17px"  src="https://upload.wikimedia.org/wikipedia/commons/b/ba/Flag_of_Germany.svg"></v-img> -->
                    <!-- <img style="width:26px;height:17px;vertical-align: unset;" :src="language.flag"> -->
                  </div>
                  <!-- <p class="col-md-12" style="color: red;">Session Time: {{ formatTime(elapsedTime) }}</p> -->

                  <div v-if="user == null">
                    <span
                      ><v-btn
                        class="headerbtn no-border-bottom"
                        color="#003A60"
                        text
                        depressed
                        href="/login"
                        >{{ $t("login") }} &nbsp;<v-icon
                          class="super-admin-icon"
                          color="#003A60"
                          >fas fa-user-circle</v-icon
                        ></v-btn
                      ></span
                    >
                  </div>
                  <div class="reset-btn-wrap" v-else>
                    <span @click="resetSessionTimer">
                      <v-btn
                        class="session-timeout-sec headerbtn no-border-bottom"
                        color="#003A60"
                        depressed
                        text
                        v-if="user != null"
                      >
                        <div class="timeout-text-wrap">
                          <p class="timeout-text">
                            {{ $t("session_timeout_in") }}:
                          </p>
                          <p class="format-time">
                            {{ formatTime1(remainingTime) }}
                          </p>
                        </div>
                        <!-- Display time on a new line -->
                        <img
                          class="session-timeout-icon"
                          src="/static/img/session-timeout-icon.svg"
                        />
                        <!-- Stylish clock icon with increased size -->
                      </v-btn>
                    </span>
                    <span data-clarity-mask="true" class="resbtn"
                      ><v-btn
                        class="headerbtn pr-0 no-border-bottom"
                        color="#003A60"
                        text
                        depressed
                        disabled
                        >{{ user.firstname }} {{ user.lastname }}&nbsp;
                        <v-icon class="super-admin-icon" color="#003A60"
                          >fas fa-user-circle</v-icon
                        ></v-btn
                      >
                    </span>
                    <span>
                      <v-btn
                        class="headerbtn border-right-logout"
                        color="#003A60"
                        text
                        depressed
                        @click="logout()"
                      >
                        {{ $t("logout") }}
                      </v-btn>
                    </span>
                  </div>
                  <div>
                    <span class="expire-wrapper" v-if="user !== null">
                      <v-dialog
                        class="v-popup-dialog"
                        v-model="openPopUpDialog"
                        width="500"
                      >
                        <v-card class="custom-dialog session-expired-wrapper">
                          <div class="session-expired-wrap">
                            <div classs="session-expired-img">
                              <img src="/static/img/session-expired-icon.svg" />
                            </div>
                            <h5
                              class="text-center font-weight-bold text-black expired-text"
                            >
                              {{ $t("session_expire") }}
                            </h5>
                          </div>
                          <h6 class="text-center logout-msg">
                            {{ $t("logged_out_message") }}
                          </h6>
                          <h5 class="text-center font-weight-bold text-black">
                            {{ formatTimeForPopup(popupCountdown) }}
                          </h5>
                          <h6 class="text-center font-weight-bold mb-5">
                            {{ $t("keep_working_message") }}
                          </h6>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              @click="logout()"
                              outlined
                              depressed
                              tile
                              class="cancelBtn mr-2 mb-2"
                            >
                              {{ $t("logout") }}
                            </v-btn>
                            <v-btn
                              @click="closePopup()"
                              outlined
                              depressed
                              tile
                              class="savebutton mr-2 mb-2"
                            >
                              {{ $t("keepWorking") }}
                            </v-btn>
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </span>
                    <span class="expire-wrapper" v-if="user !== null">
                      <v-dialog
                        class="v-popup-dialog"
                        v-model="openPopUpDialog1"
                        width="500"
                        persistent
                      >
                        <v-card class="custom-dialog session-expired-wrapper">
                          <div class="session-expired-wrap">
                            <div classs="session-expired-img">
                              <img src="/static/img/session-expired-icon.svg" />
                            </div>
                            <h5
                              class="text-center font-weight-bold text-black expired-text"
                            >
                              {{ $t("session_expire") }}
                            </h5>
                          </div>
                          <h6 class="text-center logout-msg">
                            {{ $t("logged_out_message") }}
                          </h6>
                          <h5 class="text-center font-weight-bold text-black">
                            {{ formatTimeForPopup(remainingTime) }}
                          </h5>
                          <h6 class="text-center font-weight-bold mb-5">
                            {{ $t("keep_working_message") }}
                          </h6>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              @click="logout()"
                              outlined
                              depressed
                              tile
                              class="cancelBtn mr-2 mb-2"
                            >
                              {{ $t("logout") }}
                            </v-btn>
                            <v-btn
                              @click="resetSessionTimer()"
                              outlined
                              depressed
                              tile
                              class="savebutton mr-2 mb-2"
                            >
                              {{ $t("keepWorking") }}
                            </v-btn>
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="row col-7 pb-0 align-self-center top-right-language-wrapper mobile-top-right"
              style="display: none"
            >
              <div
                class="row justify-content-end align-self-center align-self-md-end right-menu-bar"
              >
                <div
                  class="mr-md-9 align-self-center language-flags-sec"
                  style="width: 54px"
                >
                  <v-select
                    class="languagepicker languCustWrap"
                    :menu-props="{ minWidth: '180' }"
                    v-model="selectedlanguage"
                    :items="possiblelanguagesComputed"
                    item-text="name"
                    item-value="shortForm"
                    hide-details
                    @input="setLanguage(selectedlanguage)"
                  >
                    <!-- Selected item (shows flag in the select box) -->
                    <template v-slot:selection="{ item }">
                      <img
                        style="width: 30px; height: 20px; vertical-align: unset"
                        :src="'/files/flags/' + item.flag"
                        alt="Flag"
                      />
                    </template>

                    <!-- Dropdown items -->
                    <template v-slot:item="{ item }">
                      <!-- Tooltip only for Russia -->
                      <v-tooltip
                        v-if="item.shortForm === 'RU'"
                        bottom
                        class="custom_tip"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-bind="attrs"
                            v-on="on"
                            style="display: flex; align-items: center"
                          >
                            <img
                              style="
                                width: 30px;
                                height: 20px;
                                margin-right: 5px;
                              "
                              :src="'/files/flags/' + item.flag"
                              alt="Flag"
                            />
                            {{
                              item.shortForm === "RU"
                                ? item.name + " *"
                                : item.name
                            }}
                          </div>
                        </template>
                        <span>{{ $t("menu_tooltip_text") }}</span>
                        <!-- Dynamic Tooltip Text -->
                      </v-tooltip>

                      <!-- Normal display for other countries (No tooltip) -->
                      <div v-else style="display: flex; align-items: center">
                        <img
                          style="width: 30px; height: 20px; margin-right: 5px"
                          :src="'/files/flags/' + item.flag"
                          alt="Flag"
                        />
                        {{
                          item.shortForm === "RU" ? item.name + " *" : item.name
                        }}
                      </div>
                    </template>
                  </v-select>
                  <!-- <v-img @click="nothing()" width="26px" height="17px"  src="https://upload.wikimedia.org/wikipedia/commons/b/ba/Flag_of_Germany.svg"></v-img> -->
                  <!-- <img style="width:26px;height:17px;vertical-align: unset;" :src="language.flag"> -->
                </div>
                <!-- <p class="col-md-12" style="color: red;">Session Time: {{ formatTime(elapsedTime) }}</p> -->

                <div v-if="user == null">
                  <span
                    ><v-btn
                      class="headerbtn no-border-bottom"
                      color="#003A60"
                      text
                      depressed
                      href="/login"
                      >{{ $t("login") }} &nbsp;<v-icon color="#003A60"
                        >fas fa-user-circle</v-icon
                      ></v-btn
                    ></span
                  >
                </div>
                <div class="reset-btn-wrap" v-else>
                  <span @click="resetSessionTimer">
                    <v-btn
                      class="session-timeout-sec headerbtn no-border-bottom"
                      color="#003A60"
                      depressed
                      text
                      v-if="user != null"
                    >
                      <div class="timeout-text-wrap">
                        <p class="timeout-text">
                          {{ $t("session_timeout_in") }}:
                        </p>
                        <p class="format-time">
                          {{ formatTime1(remainingTime) }}
                        </p>
                      </div>
                      <!-- Display time on a new line -->
                      <img
                        class="session-timeout-icon"
                        src="/static/img/session-timeout-icon.svg"
                      />
                      <!-- Stylish clock icon with increased size -->
                    </v-btn>
                  </span>
                  <span class="resbtn"
                    ><v-btn
                      class="headerbtn pr-0 no-border-bottom super-admin-m"
                      color="#003A60"
                      text
                      depressed
                      disabled
                      >{{ user.firstname }} {{ user.lastname }}&nbsp;
                      <v-icon class="super-admin-icon" color="#003A60"
                        >fas fa-user-circle</v-icon
                      ></v-btn
                    ></span
                  >
                  <span>
                    <v-btn
                      class="headerbtn border-right-logout"
                      color="#003A60"
                      text
                      depressed
                      @click="logout()"
                    >
                      {{ $t("logout") }}
                    </v-btn>
                  </span>
                </div>
                <div></div>
              </div>
            </div>
          </div>
          <div
            class="row col-md-12 pl-8 px-0 py-0 justify-content-between main-menu-text"
          >
            <v-btn
              :class="{ 'bold-text': selectedButton === 'categories' }"
              to="/categories"
              :ripple="false"
              class="mr-2 no-background-hover headerbtn mbres"
              text
              large
              @click="removeSalesListSession"
              >{{ $t("training categories") }}</v-btn
            >
            <!-- <v-btn
              :class="{ 'bold-text': selectedButton === 'learning' }"
              to="/learning"
              :ripple="false"
              class="mr-2 no-background-hover headerbtn mbres"
              text
              large
              >{{ $t("learning-btn") }}</v-btn
            > -->
            <v-btn
              :class="{ 'bold-text': selectedButton === 'training-events' }"
              to="/training-events"
              v-show="user != null && $rights.includes('VIEW_TRAINING_EVENT')"
              :ripple="false"
              class="mr-2 no-background-hover headerbtn mbres"
              text
              large
              @click="removeSalesListSession"
              >{{ $t("trainingevents") }}</v-btn
            >
            <v-btn
              :class="{ 'bold-text': selectedButton === 'users' }"
              to="/users"
              v-show="user != null && $rights.includes('VIEW_USER')"
              :ripple="false"
              class="mr-2 no-background-hover headerbtn mbres"
              text
              large
              @click="removeSalesListSession"
              >{{ $t("user management") }}</v-btn
            >
            <v-btn
              :class="{ 'bold-text': selectedButton === 'calendar' }"
              to="/calendar"
              v-show="user != null && $rights.includes('VIEW_APPOINTMENTS')"
              :ripple="false"
              class="mr-2 no-background-hover headerbtn mbres"
              text
              large
              @click="removeSalesListSession"
              >{{ $t("schedule overview") }}</v-btn
            >

            <v-menu
              class="menu-content"
              :close-on-content-click="false"
              open-on-hover
              tile
              bottom
              offset-y
              min-width="100%"
              style="border-bottom: 5px solid var(--beige)"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :class="{ 'bold-text': selectedButton === 'tools' }"
                  v-on="on"
                  v-show="user == null"
                  :ripple="false"
                  class="mr-2 no-background-hover headerbtn mbres"
                  text
                  large
                  @click="removeSalesListSession"
                  >{{ $t("tools") }}</v-btn
                >
              </template>
              <v-list class="pt-0 pb-0">
                <div class="row menu-row">
                  <div class="col-xl-9 menu_mega">
                    <div class="col-4">
                      <v-btn
                        :href="`/tools/practical`"
                        :ripple="false"
                        class="justify-start mr-2 no-background-hover menubtn mbres"
                        text
                        large
                        @click="removeSalesListSession"
                        >{{ $t("practical training") }}</v-btn
                      >
                    </div>
                    <div class="col-4">
                      <v-btn
                        :href="`/tools/technical`"
                        :ripple="false"
                        class="justify-start mr-2 no-background-hover menubtn mbres"
                        text
                        large
                        @click="removeSalesListSession"
                        >{{ $t("technical coaching") }}</v-btn
                      >
                    </div>
                    <div class="col-4">
                      <v-btn
                        :href="`/tools/virtualclassroom`"
                        :ripple="false"
                        class="justify-start mr-2 no-background-hover menubtn mbres"
                        text
                        large
                        @click="removeSalesListSession"
                        >{{ $t("virtual classroom") }}</v-btn
                      >
                    </div>
                    <div class="col-4">
                      <v-btn
                        :href="`/tools/theory`"
                        :ripple="false"
                        class="justify-start mr-2 no-background-hover menubtn mbres"
                        text
                        large
                        @click="removeSalesListSession"
                        >{{ $t("theory training") }}</v-btn
                      >
                    </div>
                    <div class="col-4">
                      <v-btn
                        :href="`/tools/advisory`"
                        :ripple="false"
                        class="justify-start mr-2 no-background-hover menubtn mbres"
                        text
                        large
                        @click="removeSalesListSession"
                        >{{ $t("advisory") }}</v-btn
                      >
                    </div>
                    <div class="col-4">
                      <v-btn
                        :href="`/tools/virtualreality`"
                        :ripple="false"
                        class="justify-start mr-2 no-background-hover menubtn mbres"
                        text
                        large
                        @click="removeSalesListSession"
                        >{{ $t("virtual reality") }}</v-btn
                      >
                    </div>
                  </div>
                  <div class="col-xl-3 p-0">
                    <div class="sixteentonine">
                      <div
                        class="kachelimage block-background-image"
                        style="
                          background-image: url('/static/img/tools_header.jpg');
                        "
                      >
                        <div class="tools-headline">
                          <h5 class="white--text py-1 mb-0">
                            {{ $t("training_tools_of_the_learning_platform") }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-list>
            </v-menu>

            <v-menu
              class="menu-content"
              :close-on-content-click="false"
              open-on-hover
              bottom
              offset-y
              tile
              min-width="100%"
              style="border-bottom: 5px solid var(--beige)"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :class="{ 'bold-text': selectedButton === 'offer' }"
                  v-on="on"
                  v-show="user == null"
                  :ripple="false"
                  class="mr-2 no-background-hover headerbtn mbres"
                  text
                  large
                  @click="removeSalesListSession"
                  >{{ $t("offer") }}</v-btn
                >
              </template>
              <v-list class="pt-0 pb-0">
                <div class="row menu-row">
                  <div class="col-xl-9 menu_mega">
                    <div class="col-12 col-xl-4">
                      <v-btn
                        :href="`/offers/producttraining`"
                        :ripple="false"
                        class="justify-start mr-2 no-background-hover menubtn mbres"
                        text
                        large
                        @click="removeSalesListSession"
                        >{{ $t("producttraining") }}</v-btn
                      >
                    </div>
                    <div class="col-12 col-xl-4">
                      <v-btn
                        :href="`/offers/pressure`"
                        :ripple="false"
                        class="justify-start mr-2 no-background-hover menubtn mbres"
                        text
                        large
                        @click="removeSalesListSession"
                        >{{ $t("pressure") }}</v-btn
                      >
                    </div>
                    <div class="col-12 col-xl-4">
                      <v-btn
                        :href="`/offers/hydraulic`"
                        :ripple="false"
                        class="justify-start mr-2 no-background-hover menubtn mbres"
                        text
                        large
                        @click="removeSalesListSession"
                        >{{ $t("hydraulic") }}</v-btn
                      >
                    </div>
                  </div>
                  <div class="col-xl-3 p-0">
                    <div class="sixteentonine">
                      <div
                        class="block-background-image kachelimage"
                        style="
                          background-image: url('/static/img/offers_header.jpg');
                        "
                      >
                        <div class="tools-headline">
                          <h5 class="white--text py-1 mb-0">
                            {{
                              $t("training_programmes_on_the_learning_platform")
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-list>
            </v-menu>

            <v-btn
              :class="{ 'bold-text': selectedButton === 'tenants' }"
              to="/tenants"
              v-show="user != null && $rights.includes('VIEW_CUSTOMERS')"
              :ripple="false"
              class="mr-2 no-background-hover headerbtn mbres"
              text
              large
              @click="removeSalesListSession"
              >{{ $t("tenants") }}</v-btn
            >
            <v-btn
              :class="{ 'bold-text': selectedButton === 'videos' }"
              to="/videos"
              v-show="user == null"
              :ripple="false"
              class="mr-2 no-background-hover headerbtn mbres"
              text
              large
              @click="removeSalesListSession"
              >{{ $t("videos") }}</v-btn
            >
            <!-- <v-btn
              :class="{ 'bold-text': selectedButton === 'unity' }"
              to="/unity"
               v-show="user != null && $rights.includes('DIGITAL_TWIN')"
              :ripple="false"
              class="mr-2 no-background-hover headerbtn mbres"
              :style="'color:blue'"
              text
              large
              >{{ $t("digitaltwin") }}</v-btn
            > -->
            <v-btn
              :class="{ 'bold-text': selectedButton === 'contactpersons' }"
              to="/contactpersons"
              v-show="user == null"
              :ripple="false"
              class="mr-2 no-background-hover headerbtn mbres"
              text
              large
              @click="removeSalesListSession"
              >{{ $t("contactpersons") }}</v-btn
            >
            <v-btn
              :class="{ 'bold-text': selectedButton === 'uploadvideo' }"
              to="/uploadvideo"
              v-show="user != null && $rights.includes('VIEW_VIDEO')"
              :ripple="false"
              class="mr-2 no-background-hover headerbtn mbres"
              text
              large
              @click="removeSalesListSession"
              >{{ $t("videos") }}</v-btn
            >

            <!-- Veranstaltungsorte sollen öffentlich anders dargestellt werden als wenn man eingeloggt ist und diese verwaltet -->
            <v-btn
              :class="{ 'bold-text': selectedButton === 'ourvenues' }"
              to="/ourvenues"
              v-show="user == null"
              :ripple="false"
              class="mr-2 no-background-hover headerbtn mbres"
              text
              large
              @click="removeSalesListSession"
              >{{ $t("venues") }}</v-btn
            >
            <v-btn
              :class="{ 'bold-text': selectedButton === 'venues' }"
              to="/venues"
              v-show="user != null && $rights.includes('VIEW_LOCATION')"
              :ripple="false"
              class="mr-2 no-background-hover headerbtn mbres"
              text
              large
              @click="removeSalesListSession"
              >{{ $t("venues") }}</v-btn
            >
            <v-btn
              :class="{ 'bold-text': selectedButton === 'training-requests' }"
              to="/training-requests"
              v-show="
                user != null && $rights.includes('VIEW_TRAINING_REQUESTS')
              "
              :ripple="false"
              class="mr-2 no-background-hover headerbtn mbres"
              text
              large
              @click="removeSalesListSession"
              >{{ $t("training_requests") }}</v-btn
            >
            <v-btn
              :class="{ 'bold-text': selectedButton === 'aboutus' }"
              to="/aboutus"
              v-show="user == null"
              :ripple="false"
              class="mr-2 no-background-hover headerbtn mbres"
              text
              large
              @click="removeSalesListSession"
              >{{ $t("aboutus") }}</v-btn
            >
            <v-btn
              :class="{ 'bold-text': selectedButton === 'training-requests' }"
              to="/request"
              v-show="
                user == null ||
                (user.external &&
                  !$rights.includes('VIEW_TRAINING_REQUESTS')) ||
                (user.trainer && !$rights.includes('VIEW_TRAINING_REQUESTS')) ||
                (user && !$rights.includes('VIEW_TRAINING_REQUESTS'))
              "
              :ripple="false"
              class="mr-2 no-background-hover headerbtn mbres"
              text
              large
              @click="removeSalesListSession"
              >{{ $t("training_request") }}</v-btn
            >
            <v-btn
              :class="{ 'bold-text': selectedButton === 'sales-list' }"
              to="/sales-list"
              v-show="user != null && $rights.includes('VIEW_SALESLIST')"
              :ripple="false"
              class="mr-2 no-background-hover headerbtn mbres"
              text
              large
              @click="removeSalesListSession"
              >{{ $t("sales-list") }}</v-btn
            >
            <!-- <v-btn :ripple="false" class="mr-2 no-background-hover headerbtn" text large>MEINE LEHRER</v-btn> -->
          </div>
          <div class="header-divider"></div>
        </div>
      </v-app-bar>
      <v-navigation-drawer
        class="left-nav pt-0 pt-lg-16 d-xl-none"
        v-bind:style="
          drawer ? 'transform: scaleY(100%)' : 'transform: scaleY(0%)'
        "
        app
        clipped
        v-model="drawer"
      >
        <!-- <div class="nav-img-container">
          <img class="d-xl-none" src="../assets/img/kb-logo.svg" alt="" style="height:75px">
        </div> -->
        <v-list nav class="p-0">
          <v-list-item
            class="mb-0 d-xl-none"
            href="/categories"
            @click="removeSalesListSession"
          >
            <v-list-item-content>
              <v-list-item-title class="text-uppercase font-16px">
                {{ $t("training categories") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item class="d-xl-none" to="/learning">
            <v-list-item-content>
              <v-list-item-title class="text-uppercase font-16px">
                {{ $t("learning-btn") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
          <v-list-group
            :value="false"
            class="d-xl-none group-pl"
            v-show="user == null"
            @click="
              mobileMenu.group1_expanded = !mobileMenu.group1_expanded;
              mobileMenu.group2_expanded = false;
            "
          >
            <template v-slot:appendIcon>
              <img
                class="ml-2 left-nav-icon"
                src="../assets/img/arrow_right_blue.svg"
                v-bind:style="
                  mobileMenu.group1_expanded
                    ? 'transform: rotate(270deg)'
                    : 'transform: rotate(90deg)'
                "
                height="20px"
              />
            </template>
            <template v-slot:activator>
              <v-list-item-title class="text-uppercase font-16px">
                {{ $t("tools") }}
              </v-list-item-title>
            </template>

            <v-list-item
              sub-group
              link
              class="d-xl-none"
              v-show="user == null"
              :href="`/offers/producttraining`"
              @click="removeSalesListSession"
            >
              <v-list-item-content>
                <v-list-item-title class="text-uppercase font-16px">
                  {{ $t("practical training") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              sub-group
              link
              class="d-xl-none"
              v-show="user == null"
              :href="`/tools/technical`"
              @click="removeSalesListSession"
            >
              <v-list-item-content>
                <v-list-item-title class="text-uppercase font-16px">
                  {{ $t("technical coaching") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              sub-group
              link
              class="d-xl-none"
              v-show="user == null"
              :href="`/tools/virtualclassroom`"
              @click="removeSalesListSession"
            >
              <v-list-item-content>
                <v-list-item-title class="text-uppercase font-16px">
                  {{ $t("virtual classroom") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              sub-group
              link
              class="d-xl-none"
              v-show="user == null"
              :href="`/tools/theory`"
              @click="removeSalesListSession"
            >
              <v-list-item-content>
                <v-list-item-title class="text-uppercase font-16px">
                  {{ $t("theory training") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              sub-group
              link
              class="d-xl-none"
              v-show="user == null"
              :href="`/tools/advisory`"
              @click="removeSalesListSession"
            >
              <v-list-item-content>
                <v-list-item-title class="text-uppercase font-16px">
                  {{ $t("advisory") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              sub-group
              link
              class="d-xl-none"
              v-show="user == null"
              :href="`/tools/virtualreality`"
              @click="removeSalesListSession"
            >
              <v-list-item-content>
                <v-list-item-title class="text-uppercase font-16px">
                  {{ $t("virtual reality") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-group
            :value="false"
            class="d-xl-none group-pl"
            v-show="user == null"
            @click="
              mobileMenu.group2_expanded = !mobileMenu.group2_expanded;
              mobileMenu.group1_expanded = false;
            "
          >
            <template v-slot:appendIcon>
              <img
                class="ml-2 left-nav-icon"
                src="../assets/img/arrow_right_blue.svg"
                v-bind:style="
                  mobileMenu.group2_expanded
                    ? 'transform: rotate(270deg)'
                    : 'transform: rotate(90deg)'
                "
                height="20px"
              />
            </template>
            <template v-slot:activator>
              <v-list-item-title class="text-uppercase font-16px">
                {{ $t("offer") }}
              </v-list-item-title>
            </template>

            <v-list-item
              sub-group
              link
              class="d-xl-none"
              v-show="user == null"
              :href="`/offers/producttraining`"
              @click="removeSalesListSession"
            >
              <v-list-item-content>
                <v-list-item-title class="text-uppercase font-16px">
                  {{ $t("producttraining") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              sub-group
              link
              class="d-xl-none"
              v-show="user == null"
              :href="`/offers/pressure`"
              @click="removeSalesListSession"
            >
              <v-list-item-content>
                <v-list-item-title class="text-uppercase font-16px">
                  {{ $t("pressure") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              sub-group
              link
              class="d-xl-none"
              v-show="user == null"
              :href="`/offers/hydraulic`"
              @click="removeSalesListSession"
            >
              <v-list-item-content>
                <v-list-item-title class="text-uppercase font-16px">
                  {{ $t("hydraulic") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item
            v-show="user != null && $rights.includes('VIEW_TRAINING_EVENT')"
            class="d-xl-none"
            to="/training-events"
            @click="removeSalesListSession"
          >
            <v-list-item-content>
              <v-list-item-title class="text-uppercase font-16px">
                {{ $t("trainingevents") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-show="user != null && $rights.includes('VIEW_USER')"
            class="d-xl-none"
            to="/users"
            @click="removeSalesListSession"
          >
            <v-list-item-content>
              <v-list-item-title class="text-uppercase font-16px">
                {{ $t("user management") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            class="d-xl-none"
            to="/calendar"
            v-show="$rights.includes('VIEW_APPOINTMENTS')"
            @click="removeSalesListSession"
          >
            <v-list-item-content>
              <v-list-item-title class="text-uppercase font-16px">
                {{ $t("schedule overview") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            class="d-xl-none"
            to="/tenants"
            @click="removeSalesListSession"
            v-show="user != null && $rights.includes('VIEW_CUSTOMERS')"
          >
            <v-list-item-content>
              <v-list-item-title class="text-uppercase font-16px">
                {{ $t("tenants") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- <v-list-item
            class="d-xl-none"
            to="/unity"
            v-show="user != null && $rights.includes('DIGITAL_TWIN')"
          >
            <v-list-item-content>
              <v-list-item-title class="text-uppercase font-16px">
                {{ $t("digitaltwin") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
       -->

          <v-list-item
            class="d-xl-none"
            to="/videos"
            v-show="user == null"
            @click="removeSalesListSession"
          >
            <v-list-item-content>
              <v-list-item-title class="text-uppercase font-16px">
                {{ $t("videos") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/contactpersons"
            v-show="user == null"
            class="d-xl-none"
            @click="removeSalesListSession"
          >
            <v-list-item-content>
              <v-list-item-title class="text-uppercase font-16px">
                {{ $t("contactpersons") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/uploadvideo"
            @click="removeSalesListSession"
            v-show="$rights.includes('VIEW_VIDEO')"
            class="d-xl-none"
          >
            <v-list-item-content>
              <v-list-item-title class="text-uppercase font-16px">
                {{ $t("videos") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            class="d-xl-none"
            to="/venues"
            @click="removeSalesListSession"
            v-show="$rights.includes('VIEW_LOCATION')"
          >
            <v-list-item-content>
              <v-list-item-title class="text-uppercase font-16px">
                {{ $t("venues") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/ourvenues"
            v-show="user == null"
            @click="removeSalesListSession"
            class="d-xl-none"
          >
            <v-list-item-content>
              <v-list-item-title class="text-uppercase font-16px">
                {{ $t("venues") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- <v-list-item href="/" class="d-xl-none">
            <v-list-item-content>
              <v-list-item-title class="text-uppercase font-18px">
                {{$t("contact")}}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          <v-list-item
            href="/aboutus"
            @click="removeSalesListSession"
            class="d-xl-none"
            v-show="user == null"
          >
            <v-list-item-content>
              <v-list-item-title class="text-uppercase font-16px">
                {{ $t("aboutus") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-show="user != null && $rights.includes('VIEW_TRAINING_REQUESTS')"
            href="/training-requests"
            class="d-xl-none"
            @click="removeSalesListSession"
          >
            <v-list-item-content>
              <v-list-item-title class="text-uppercase font-16px">
                {{ $t("training_requests") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            href="/request"
            @click="removeSalesListSession"
            class="d-xl-none"
            v-show="
              user == null ||
              (user.external && !$rights.includes('VIEW_TRAINING_REQUESTS')) ||
              (user.trainer && !$rights.includes('VIEW_TRAINING_REQUESTS')) ||
              (user && !$rights.includes('VIEW_TRAINING_REQUESTS'))
            "
          >
            <v-list-item-content>
              <v-list-item-title class="text-uppercase font-16px">
                {{ $t("training_request") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-show="user != null && $rights.includes('VIEW_SALESLIST')"
            href="/sales-list"
            @click="removeSalesListSession"
            class="d-xl-none"
          >
            <v-list-item-content>
              <v-list-item-title class="text-uppercase font-16px">
                {{ $t("sales-list") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <v-main
        class="mainmobile pt-16 mb-md-0"
        style="padding: 64px 0px 35px 0px"
      >
        <router-view></router-view>
      </v-main>
      <!-- <v-row>
        <div class="col col-lg-2 no-padding"></div>
        <div class="col-lg-10"></div>
      </v-row> -->
      <v-bottom-navigation
        :input-value="footdrawer"
        scroll-target="#scroll-threshold-example"
        class="pl-4 pl-md-8 text-left"
        scroll-threshold="500"
        app
        absolute
        hide-on-scroll
        text
        horizontal
        style="height: auto; background-color: var(--blue); display: block"
      >
        <!-- <v-btn v-bind:class="{'close':footdrawer}" class="footerbtn d-md-none" @click="footdrawer = !footdrawer" fab style="position:absolute;background-color:#003A60;z-index:1;top:-24px;"><v-icon  class="mr-0" v-show="!footdrawer" color="white">fas fa-chevron-up</v-icon><v-icon class="mr-0" v-show="footdrawer" color="white">fas fa-chevron-down</v-icon></v-btn> -->
        <div class="footer" v-bind:class="{ open: drawer }">
          <v-btn
            :ripple="false"
            text
            class="py-6 footerbtn text-uppercase no-background-hover"
            href="/"
            @click="removeSalesListSession"
            >{{ $t("Homepage") }}</v-btn
          >
          <v-btn
            :ripple="false"
            href="/imprint"
            @click="removeSalesListSession"
            text
            class="py-6 footerbtn text-uppercase no-background-hover"
            >{{ $t("imprint") }}</v-btn
          >
          <!-- Important: When changing the Link to the Privacy Policy, the link needs to be changed in mail_footer.html too! -->
          <v-btn
            target="_blank"
            :href="`/files/images/KB_DS-Hinweise_knorr-bremse.com_DE_20220310_Website_${$locale}.pdf`"
            :ripple="false"
            text
            @click="removeSalesListSession"
            class="py-6 footerbtn text-uppercase no-background-hover"
            >{{ $t("privacy") }}</v-btn
          >
          <v-btn
            :ripple="false"
            href="/cookies"
            text
            @click="removeSalesListSession"
            class="py-6 footerbtn text-uppercase no-background-hover"
            >{{ $t("cookies") }}</v-btn
          >
          <v-btn
            @click="
              () => {
                log();
                removeSalesListSession();
              }
            "
            target="_blank"
            :href="
              selectedlanguage == 'DE'
                ? '/files/images/Leistungsbedingungen_KB_Rail_Services_Trainingsakademie_Germany.pdf'
                : selectedlanguage == 'PL'
                ? '/files/images/Leistungsbedinungen_KB_RailServices_Trainingsakademie_Germany_pl.pdf'
                : selectedlanguage == 'FR'
                ? '/files/images/Leistungsbedinungen_KB_RailServices_Trainingsakademie_Germany_fr.pdf'
                : selectedlanguage == 'HU'
                ? '/files/images/Leistungsbedinungen_KB_RailServices_Trainingsakademie_Germany_hu.pdf'
                : selectedlanguage == 'ES'
                ? '/files/images/Leistungsbedinungen_KB_RailServices_Trainingsakademie_Germany_es.pdf'
                : selectedlanguage == 'KK'
                ? '/files/images/Leistungsbedinungen_KB_RailServices_Trainingsakademie_Germany_kk.pdf'
                : selectedlanguage == 'RU'
                ? '/files/images/Leistungsbedinungen_KB_RailServices_Trainingsakademie_Germany_ru.pdf'
                : selectedlanguage == 'ZH'
                ? '/files/images/Leistungsbedinungen_KB_RailServices_Trainingsakademie_Germany_zh.pdf'
                : selectedlanguage == 'IT'
                ? '/files/images/Leistungsbedinungen_KB_RailServices_Trainingsakademie_Germany_it.pdf'
                : '/files/images/General_performance_KB_RailServices_Trainingsakademie_Germany.pdf'
            "
            :ripple="false"
            text
            class="py-6 footerbtn text-uppercase no-background-hover"
            >{{ $t("agb") }}</v-btn
          >
          <v-btn
            @click="
              () => {
                showCatalog();
                removeSalesListSession();
              }
            "
            :ripple="false"
            text
            class="py-6 footerbtn text-uppercase no-background-hover"
            >{{ $t("catalog") }}</v-btn
          >
          <v-btn
            @click="removeSalesListSession"
            :ripple="false"
            text
            class="py-6 footerbtn text-uppercase no-background-hover"
            to="/contact"
            >{{ $t("contact") }}</v-btn
          >
        </div>
      </v-bottom-navigation>
    </v-app>
  </div>
</template>
<script>
import IdleJs from "idle-js";
import TimerWorker from "worker-loader!../workers/timerWorker.js";
import { eventBus } from "../main.js";

export default {
  name: "app",
  data() {
    return {
      selectedButton: null,
      idle: null,
      popupTimer: null,
      popupCountdown: null,
      drawer: null,
      footdrawer: true,
      selectedlanguage: null,
      possiblelanguages: [],
      currentRouteName: null,
      openPopUpDialog: false,
      openPopUpDialog1: false,
      standardRoutes: [
        {
          key: "objects",
          name: this.$t("objects"),
          icon: "fas fa-bomb",
          to: "/findings",
        },
        {
          key: "masterdata",
          name: this.$t("masterdata"),
          icon: "fas fa-database",
          to: "/masterdata",
          right: "WriteMasterdata",
        },
        {
          key: "users",
          name: this.$t("users"),
          icon: "fas fa-user",
          to: "/users",
          right: "ReadUsers",
        },
        {
          key: "roles",
          name: this.$t("roles"),
          icon: "fas fa-user-tag",
          to: "/roles",
          right: "WriteUsers",
        },
        {
          key: "customers",
          name: this.$t("customers"),
          icon: "fas fa-user-tie",
          to: "/customers",
          right: "GlobalAccess",
        },
      ],
      loginRoute: {
        key: "login",
        name: this.$t("login"),
        icon: "fas fa-user",
        to: "/login",
      },
      logoutRoute: {
        key: "logout",
        name: this.$t("logout"),
        icon: "fas fa-sign-out-alt",
      },
      allowedRoutes: [],
      user: null,
      language: {
        language: null,
        flag: null,
        shortForm: null,
      },
      languages: [],

      mobileMenu: {
        group1_expanded: false,
        group2_expanded: false,
      },
      worker: null,
      elapsedTime: 0,
      duration: 20 * 60 * 1000, // 1 minute
      countingDown: false,
      remainingTime: 0,
    };
  },

  mounted() {
    this.getCurrentUser();
    // this.idle = new IdleJs({
    //   idle: 10 * 60 * 1000, // 10 minutes in milliseconds
    //   events: ["mousemove", "keydown"],
    //   onIdle: () => {
    //     // Trigger popup or perform actions when user becomes idle
    //     if (!this.openPopUpDialog) {
    //       this.openPopUpDialog = true;
    //       this.startPopupTimer();
    //     }
    //   },
    //   onActive: () => {
    //     if (!this.openPopUpDialog) {
    //       // Reset idle timeout or perform actions when user becomes active
    //       this.resetPopupTimer();
    //     }
    //   },
    // });
    // this.idle.start();
    // this.startBackgroundPopupTimer();
    this.getLanguages();

    if (
      this.$route.path == "/otp-verification" ||
      this.$route.path == "/download-documents"
    ) {
      document.body.classList.add("optScreensWrap");
    } else {
    }
  },

  computed: {
    //   tooltipText() {
    //   switch (this.selectedlanguage) {
    //     case "EN":
    //       return "For Kazakhstan"; // Tooltip text for English users
    //     case "DE":
    //       return "Für Kasachstan"; // Tooltip text for German users
    //     case "FR":
    //       return "Pour le Kazakhstan";
    //     case "ES":
    //       return "Para Kazajstán";
    //     case "PL":
    //       return "Dla Kazachstanu";
    //     case "HU":
    //       return "Kazahsztán esetében";
    //     case "KK":
    //       return "Қазақстан үшін";
    //     case "RU":
    //       return "Для Казахстана";
    //     case "IT":
    //       return "Per il Kazakistan";
    //     default:
    //       return "For Kazakhstan";
    //   }
    // },

    possiblelanguagesComputed() {
      return this.possiblelanguages.map((language) => ({
        name: this.$t(language.name),
        flag: language.flag,
        shortForm: language.shortForm,
      }));
    },
    mini() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
  },
  methods: {
    removeSalesListSession() {
      sessionStorage.removeItem("subscriptionData");

      sessionStorage.removeItem("salesMonth");
      sessionStorage.removeItem("salesContact");
      sessionStorage.removeItem("customer");
      sessionStorage.removeItem("salesCountry");
      sessionStorage.removeItem("orderDate");
      sessionStorage.removeItem("effectiveDate");
      sessionStorage.removeItem("dateOfInvoice");
      sessionStorage.removeItem("eventNumber");
      sessionStorage.removeItem("billNumber");
      sessionStorage.removeItem("invoiceAmount");
      sessionStorage.removeItem("offerAmount");
      sessionStorage.removeItem("offerNumber");
      sessionStorage.removeItem("debtorNumber");
      sessionStorage.removeItem("processingStatus");
      sessionStorage.removeItem("salesSource");
      sessionStorage.removeItem("serviceOrder");
      sessionStorage.removeItem("activeTab");
      sessionStorage.removeItem("filter");
      sessionStorage.removeItem("projectNumberText");

      // events

      sessionStorage.removeItem("startDateEvent");
      sessionStorage.removeItem("eventNumberEvent");
      sessionStorage.removeItem("trainingname");
      sessionStorage.removeItem("eventTrainingCategoryName");
      sessionStorage.removeItem("vehicleType");
      sessionStorage.removeItem("locationFormatted");
      sessionStorage.removeItem("trainers");
      sessionStorage.removeItem("name");
      sessionStorage.removeItem("status");

      sessionStorage.removeItem("startDateEventInactive");
      sessionStorage.removeItem("eventNumberEventInactive");
      sessionStorage.removeItem("trainingnameInactive");
      sessionStorage.removeItem("eventTrainingCategoryNameInactive");
      sessionStorage.removeItem("vehicleTypeInactive");
      sessionStorage.removeItem("locationFormattedInactive");
      sessionStorage.removeItem("trainersInactive");
      sessionStorage.removeItem("nameInactive");
      sessionStorage.removeItem("statusInactive");
      sessionStorage.removeItem("filterInactive");
    },
    // startPopupTimer() {
    //   // Method to start the popup countdown timer
    //   this.popupCountdown = 10 * 60; // 10 minutes in seconds
    //   this.popupTimer = setInterval(() => {
    //     if (this.popupCountdown <= 0) {
    //       this.logout(); // Call your logout function or redirect to the login page
    //     }
    //     if (this.popupCountdown > 0) {
    //       this.popupCountdown--;
    //     } else {
    //       clearInterval(this.popupTimer);
    //       this.popupTimer = null;
    //     //  this.openPopUpDialog = true; // Display the popup
    //     }
    //   }, 1000); // Update countdown every second
    // },
    // resetPopupTimer() {
    //   // Method to reset the popup countdown timer
    //   clearInterval(this.popupTimer); // Clear existing timer
    //   this.popupTimer = null;
    // },
    // closePopup() {
    //   clearInterval(this.popupTimer); // Clear existing timer
    //   this.popupTimer = null;
    //   this.openPopUpDialog = false;
    // },

    resetSessionTimer() {
      this.openPopUpDialog1 = false;
      localStorage.removeItem("elapsedTime2");
      this.$resetSessionTimer();
    },

    // Function to show reset popup when remaining time is 1 hour 50 minutes
    // showResetPopup() {
    //   // Implement your logic to show a popup to reset the timer here
    //   this.openPopUpDialog = true;
    // },
    // Function to format time as HH:MM:SS
    formatTime(timeInSeconds) {
      const hours = Math.floor(timeInSeconds / 3600);
      const minutes = Math.floor((timeInSeconds % 3600) / 60);
      const seconds = timeInSeconds % 60;
      return `${this.padTime(hours)}:${this.padTime(minutes)}:${this.padTime(
        seconds
      )}`;
    },
    startBackgroundPopupTimer() {
      let logoutTimer = null;

      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden") {
          clearTimeout(logoutTimer);
          logoutTimer = null; // Reset the timer to prevent premature logout if user comes back within 2 minutes
          setTimeout(() => {
            this.logout(); // Logout the user after 20 minutes of no visibility
          }, 20 * 60 * 1000);
        } else {
          // Reset the logout timer when the user comes back to the screen
          clearTimeout(logoutTimer);
          logoutTimer = null;
        }
      });
    },

    // Function to pad time with leading zeros if necessary
    padTime(time) {
      return time < 10 ? `0${time}` : time;
    },

    getCurrentUser() {
      progressIndicator.hidden = false;
      this.$axios
        .get("/api/user/me")
        .then(this.gotCurrentUser)
        .catch(this.getCurrentUserFailed)
        .finally(this.requestEnded);
    },
    gotCurrentUser(response) {
      //  localStorage.removeItem("langChange");
      this.user = response.data;
      Vue.prototype.$user = this.user;
      Vue.prototype.$rights = this.user.allRights;
      Vue.prototype.$external = this.user.external;

      this.allowedRoutes = [];
      for (let i = 0; i < this.standardRoutes.length; i++) {
        const route = this.standardRoutes[i];
        if (route.right == null || this.hasRight(route.right)) {
          this.allowedRoutes.push(route);
        }
      }
      this.getCurrentLanguage();
      this.$startSessionCountdown();
      eventBus.$on("remaining-time-updated", (time) => {
        this.remainingTime = time;
        if (time == 10 * 60 * 1000) {
          this.openPopUpDialog1 = true;
        } else if (time == 0) {
          this.openPopUpDialog1 = false;
          localStorage.removeItem("elapsedTime2");
          Vue.prototype.$destroyTimer();
          this.logout();
        }
      });
    },
    getCurrentUserFailed(error) {
      this.user = null;
      if (localStorage.getItem("langChange") === null) {
        this.getCurrentLanguage();
      } else {
        this.setLanguageCode(localStorage.getItem("langChange"));
      }
    },
    onError(err) {
      if (
        err.response != null &&
        err.response.data != null &&
        err.response.data.message != null
      ) {
        this.$noty.error(err.response.data.message);
      } else {
        console.error(err);
      }
    },
    requestEnded() {
      progressIndicator.hidden = true;
    },

    getCurrentLanguage() {
      progressIndicator.hidden = false;
      var _this = this;
      if (localStorage.getItem("langChange") != null) {
        //   console.log('hello-lang');
        // this.$axios
        //   .get("/api/language/me")
        //   .then(function (response) {
        //     _this.language.language = response.data.language;
        //     _this.language.flag = response.data.flag;
        //     _this.selectedlanguage = response.data.shortForm;
        //     _this.$locale = _this.selectedlanguage.toLowerCase();
        //   })
        //   .catch(this.onError)
        //   .finally(this.requestEnded);
        this.setLanguageCode(localStorage.getItem("langChange"));
      } else if (localStorage.getItem("langChange") === null) {
        let countryName = _this.getCookie("country");
        console.log(countryName);
        if (countryName) {
          if (countryName.length > 2) {
            _this.setGeoLanguage(countryName);
          } else {
            _this.setLanguageCode(countryName);
          }
          return 1;
        }

        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              console.log("Request 1", position);
              // Use Axios to make the reverse geocoding request
              this.$axios
                .get(
                  `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${position.coords.latitude}&lon=${position.coords.longitude}`
                )
                .then((response) => {
                  console.log("Request1 success");
                  const data = response.data; // Access response data
                  const country = data.address.country;
                  this.location = `Latitude: ${position.coords.latitude}, Longitude: ${position.coords.longitude}, Country: ${country}`;
                  const d = new Date();
                  d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
                  let expires = "expires=" + d.toUTCString();
                  document.cookie = `country=${country};${expires};path=/`;
                  _this.setLanguageCode(country);
                })
                .catch((error) => {
                  _this.getIpCountry();
                });
            },
            (error) => {
              _this.getIpCountry();
            }
          );
        } else {
          _this.getIpCountry();
        }
      }
    },
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
    },

    getIpCountry() {
      console.log("Request 2");
      progressIndicator.hidden = false;
      var _this = this;
      let countryName = _this.getCookie("country");
      if (countryName) {
        _this.setGeoLanguage(countryName);
      } else {
        _this.$axios
          .get("https://ipapi.co/json/")
          .then((response) => {
            console.log("Request 2 success");
            const data = response.data;
            const country = data.country;
            // document.cookie = `country=${data.country_name}`;
            const d = new Date();
            d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
            let expires = "expires=" + d.toUTCString();
            document.cookie = `country=${country};${expires};path=/`;
            _this.setGeoLanguage(data.country_name);
          })
          .catch((error) => {
            console.error("Error fetching IP information:", error);
            this.loading = false;
          });
      }
    },

    setLanguageCode(data) {
      var _this = this;
      if (data === "DE") {
        _this.language.language = "GERMAN";
        _this.language.flag = "Germany.png";
        _this.selectedlanguage = "DE";
        _this.$locale = _this.selectedlanguage.toLowerCase();
      } else if (data === "PL") {
        _this.language.language = "POLISH";
        _this.language.flag = "Poland.png";
        _this.selectedlanguage = "PL";
        _this.$locale = _this.selectedlanguage.toLowerCase();
      } else if (data === "FR") {
        _this.language.language = "FRENCH";
        _this.language.flag = "France.png";
        _this.selectedlanguage = "FR";
        _this.$locale = _this.selectedlanguage.toLowerCase();
      } else if (data === "IT") {
        _this.language.language = "ITALIAN";
        _this.language.flag = "Italy.png";
        _this.selectedlanguage = "IT";
        _this.$locale = _this.selectedlanguage.toLowerCase();
      } else if (data === "ES") {
        _this.language.language = "SPANISH";
        _this.language.flag = "Spain.png";
        _this.selectedlanguage = "ES";
        _this.$locale = _this.selectedlanguage.toLowerCase();
      } else if (data === "HU") {
        _this.language.language = "HUNGARIAN";
        _this.language.flag = "Hungary.png";
        _this.selectedlanguage = "HU";
        _this.$locale = _this.selectedlanguage.toLowerCase();
      } else if (data === "RU") {
        _this.language.language = "RUSSIAN";
        _this.language.flag = "Russian_Federation.png";
        _this.selectedlanguage = "RU";
        _this.$locale = _this.selectedlanguage.toLowerCase();
      } else if (data === "KK") {
        _this.language.language = "KAZAKH";
        _this.language.flag = "Kazakhstan.png";
        _this.selectedlanguage = "KK";
        _this.$locale = _this.selectedlanguage.toLowerCase();
      } else if (data === "ZH") {
        _this.language.language = "SIMPLIFIED_CHINESE";
        _this.language.flag = "China.png";
        _this.selectedlanguage = "ZH";
        _this.$locale = _this.selectedlanguage.toLowerCase();
        console.log(_this.$locale + "langiuage code");
      } else {
        _this.language.language = "EN";
        _this.language.flag = "United_Kingdom.png";
        _this.selectedlanguage = "EN";
        _this.$locale = _this.selectedlanguage.toLowerCase();
      }
      this.loading = false;
      progressIndicator.hidden = true;
      document.body.className = document.body.className
        .split(" ")
        .filter((cls) => !cls.startsWith("lang-"))
        .join(" ")
        .trim();
      document.body.classList.add(
        "lang-" + _this.selectedlanguage.toLowerCase()
      );
    },

    setGeoLanguage(data) {
      var _this = this;
      if (data === "Germany") {
        _this.language.language = "GERMAN";
        _this.language.flag = "Germany.png";
        _this.selectedlanguage = "DE";
        _this.$locale = _this.selectedlanguage.toLowerCase();
      } else if (data === "Poland") {
        _this.language.language = "POLISH";
        _this.language.flag = "Poland.png";
        _this.selectedlanguage = "PL";
        _this.$locale = _this.selectedlanguage.toLowerCase();
      } else if (data === "France") {
        _this.language.language = "FRENCH";
        _this.language.flag = "France.png";
        _this.selectedlanguage = "FR";
        _this.$locale = _this.selectedlanguage.toLowerCase();
      } else if (data === "Italy") {
        _this.language.language = "ITALIAN";
        _this.language.flag = "Italy.png";
        _this.selectedlanguage = "IT";
        _this.$locale = _this.selectedlanguage.toLowerCase();
      } else if (data === "Spain") {
        _this.language.language = "SPANISH";
        _this.language.flag = "Spain.png";
        _this.selectedlanguage = "ES";
        _this.$locale = _this.selectedlanguage.toLowerCase();
      } else if (data === "Hungary") {
        _this.language.language = "HUNGARIAN";
        _this.language.flag = "Hungary.png";
        _this.selectedlanguage = "HU";
        _this.$locale = _this.selectedlanguage.toLowerCase();
      } else if (data === "Russia") {
        _this.language.language = "RUSSIAN";
        _this.language.flag = "Russian_Federation.png";
        _this.selectedlanguage = "RU";
        _this.$locale = _this.selectedlanguage.toLowerCase();
      } else if (data === "Kazakhstan") {
        _this.language.language = "KAZAKH";
        _this.language.flag = "Kazakhstan.png";
        _this.selectedlanguage = "KK";
        _this.$locale = _this.selectedlanguage.toLowerCase();
      } else if (data === "China") {
        _this.language.language = "SIMPLIFIED_CHINESE";
        _this.language.flag = "China.png";
        _this.selectedlanguage = "ZH";
        _this.$locale = _this.selectedlanguage.toLowerCase();
      } else {
        _this.language.language = "ENGLISH";
        _this.language.flag = "United_Kingdom.png";
        _this.selectedlanguage = "EN";
        _this.$locale = _this.selectedlanguage.toLowerCase();
      }
      this.loading = false;
      progressIndicator.hidden = true;
      document.body.className = document.body.className
        .split(" ")
        .filter((cls) => !cls.startsWith("lang-"))
        .join(" ")
        .trim();
      document.body.classList.add(
        "lang-" + _this.selectedlanguage.toLowerCase()
      );
    },

    getLanguages() {
      progressIndicator.hidden = false;
      var _this = this;
      this.$axios
        .get("/api/language/all")
        .then(function (response) {
          _this.languages = response.data;
          _this.convertLanguages(_this.languages);

          // Make function accessible for getting flag by language
          Vue.prototype.$languages = _this.languages;
        })
        .catch(this.onError)
        .finally(this.requestEnded);
    },
    convertLanguages(languages) {
      const lnlist = [];
      for (var i in languages) {
        if (languages[i].onlySelectable) continue;
        var language = {};
        var ln = languages[i].language;

        // console.log(this.$t(languages[i].language));
        language.name = languages[i].language;
        language.flag = languages[i].flag;
        language.shortForm = languages[i].shortForm;
        lnlist.push(language);
      }
      this.possiblelanguages = lnlist;
    },

    setLanguage(shortForm) {
      localStorage.setItem("langChange", shortForm);
      this.setLanguageCode(shortForm);
      let parameterNames = this.getAllParameterNamesFromURL(
        window.location.href
      );
      let containsLang = false;

      // Iterate through each parameter in the searchParams object
      for (var i = 0; i < parameterNames.length; i++) {
        // Check if the parameter is 'lang'
        if (parameterNames[i] === "lang") {
          containsLang = true;
          // Exit the loop early if 'lang' is found
          break;
        }
      }
      let firstMatchedRoute;
      let routePathWithoutQueryParams;
      if (this.$route.matched.length > 0) {
        firstMatchedRoute = this.$route.matched[0];
        routePathWithoutQueryParams = firstMatchedRoute.path.split("?")[0];
        routePathWithoutQueryParams = routePathWithoutQueryParams.replace(
          ":pathMatch(.*)*",
          ""
        );
      }
      if (
        !window.location.href.includes("?") &&
        !window.location.href.includes("?lang=")
      ) {
        window.location.href = window.location.href + "?lang=" + shortForm;
      } else if (
        !containsLang &&
        (routePathWithoutQueryParams == "/training-event-category-list" ||
          routePathWithoutQueryParams == "/training-events")
      ) {
        var updatedUrl = window.location.href.substring(
          0,
          window.location.href.indexOf("?")
        );
        window.location.href = updatedUrl + "?lang=" + shortForm;
      } else if (parameterNames.length === 1 && containsLang) {
        var updatedUrl = window.location.href.substring(
          0,
          window.location.href.indexOf("?")
        );
        window.location.href = updatedUrl + "?lang=" + shortForm;
      } else {
        var updatedUrl = window.location.href.replace(/&lang=\w{2}$/, "");
        window.location.href = updatedUrl + "&lang=" + shortForm;
      }
    },

    getAllParameterNamesFromURL(url) {
      var parsedURL = new URL(url);
      var searchParams = parsedURL.searchParams;
      var parameterNames = [];
      searchParams.forEach(function (value, key) {
        // Add the parameter name to the array
        parameterNames.push(key);
      });

      return parameterNames;
    },

    showCatalog() {
      var win = window.open("/api/downloads/catalog", "_blank");
      win.focus();
    },

    hasRight(right) {
      if (this.user.allRights.includes(right)) return true;
      return false;
    },

    toggleAuthentication() {
      if (this.user == null) {
        this.router.push("login");
      } else {
        this.logout();
      }
    },
    logout() {
      this.$axios
        .post("/logout")
        .then(this.logoutDone)
        .catch(this.logoutFailed);
    },

    logoutDone(response) {
      this.removeSalesListSession();
      this.$destroyTimer();
      this.switchToLoginPage();
    },
    logoutFailed(error) {
      this.switchToLoginPage();
    },
    switchToLoginPage() {
      this.user = null;
      this.$rights = [];
      Vue.prototype.$user = null;
      Vue.prototype.$rights = [];
      this.openPopUpDialog1 = false;
      this.openPopUpDialog = false;
      this.$axios.logout();
      this.$router.push("/login");
    },
    nothing() {},

    formatTime1(ms) {
      let seconds = Math.floor((ms / 1000) % 60);
      let minutes = Math.floor((ms / (1000 * 60)) % 60);
      let hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
      //return `${hours}:${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
      return `${this.padTime(hours)}:${this.padTime(minutes)}:${this.padTime(
        seconds
      )}`;
    },

    formatTimeForPopup(ms) {
      let seconds = Math.floor((ms / 1000) % 60);
      let minutes = Math.floor((ms / (1000 * 60)) % 60);
      let hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
      return `${this.padTime(minutes)}:${this.padTime(seconds)}`;
    },

    selectButton() {
      if (window.location.href.includes("sales-request")) {
        this.selectedButton = "sales-list";
      } else if (
        window.location.href.includes("request") ||
        window.location.href.includes("training-requests")
      ) {
        this.selectedButton = "training-requests";
      } else if (window.location.href.includes("aboutus")) {
        this.selectedButton = "aboutus";
      } else if (
        window.location.href.includes("sales-list") ||
        window.location.href.includes("projects")
      ) {
        this.selectedButton = "sales-list";
      } else if (window.location.href.includes("ourvenues")) {
        this.selectedButton = "ourvenues";
      } else if (window.location.href.includes("venues")) {
        this.selectedButton = "venues";
      } else if (window.location.href.includes("uploadvideo")) {
        this.selectedButton = "uploadvideo";
      } else if (window.location.href.includes("contactpersons")) {
        this.selectedButton = "contactpersons";
      } else if (window.location.href.includes("unity")) {
        this.selectedButton = "unity";
      } else if (
        window.location.href.includes("training-events") ||
        window.location.href.includes("create-training-event") ||
        window.location.href.includes("edit-training-event") ||
        window.location.href.includes("create-training-event") ||
        window.location.href.includes("training-event-category-list")
      ) {
        this.selectedButton = "training-events";
      } else if (window.location.href.includes("videos")) {
        this.selectedButton = "videos";
      } else if (window.location.href.includes("tenants")) {
        this.selectedButton = "tenants";
      } else if (window.location.href.includes("offer")) {
        this.selectedButton = "offer";
      } else if (window.location.href.includes("calendar")) {
        this.selectedButton = "calendar";
      } else if (window.location.href.includes("users")) {
        this.selectedButton = "users";
      } else if (window.location.href.includes("learning")) {
        this.selectedButton = "learning";
      } else if (window.location.href.includes("categories")) {
        this.selectedButton = "categories";
      } else if (window.location.href.includes("tools")) {
        this.selectedButton = "tools";
      } else if (window.location.href.includes("login")) {
        this.selectedButton = "login";
      }
    },
  },
  watch: {
    $route(to, from) {
      if (from.path === "/login" && to.path !== "/reset-password") {
        this.getCurrentUser();
      }
    },
  },
  updated() {
    this.selectButton();
  },
};
</script>
